/**
 * Copyright (c) 2026 Finorda Pty Ltd
 * All rights reserved.
 *
 * This file is part of the Finorda platform.
 * Unauthorised copying, modification or
 * distribution of this software is
 * strictly prohibited.
 *
 * Proprietary and confidential.
 * Governed by Queensland law, Australia.
 */

/**
 * StatusCards - 4 status stat cards (Total, Draft, Issued, Archived)
 * Extracted from PurchaseOrders page for POG-TD-009.
 */
function StatusCards({ stats }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '30px' }}>
      <div style={{ backgroundColor: '#f9fafb', padding: '20px', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
        <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px' }}>Total POs</div>
        <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827' }}>{stats.total}</div>
      </div>
      <div style={{ backgroundColor: '#fef3c7', padding: '20px', borderRadius: '8px', border: '1px solid #fcd34d' }}>
        <div style={{ fontSize: '14px', color: '#92400e', marginBottom: '8px' }}>Draft</div>
        <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#92400e' }}>{stats.draft}</div>
      </div>
      <div style={{ backgroundColor: '#d1fae5', padding: '20px', borderRadius: '8px', border: '1px solid #6ee7b7' }}>
        <div style={{ fontSize: '14px', color: '#065f46', marginBottom: '8px' }}>Issued</div>
        <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#065f46' }}>{stats.issued}</div>
      </div>
      <div style={{ backgroundColor: '#e5e7eb', padding: '20px', borderRadius: '8px', border: '1px solid #d1d5db' }}>
        <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px' }}>Archived</div>
        <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#6b7280' }}>{stats.archived}</div>
      </div>
    </div>
  )
}

export default StatusCards
